import { baseApi } from '@/features/api/baseApi';
import directus, { type DirectusErrorType } from '@/features/api/directus';
import type { ThesaurusRow } from '@/models/thesaurus.type';
import { triggerFlow } from '@directus/sdk';

const THESAURUS_FLOW_ID = '1e0a37cf-9261-4d61-824c-36b35fcb15b1';

const thesaurusApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['thesaurus'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getThesaurus: builder.query<ThesaurusRow[], void>({
        keepUnusedDataFor: 3600, // 1 hour
        queryFn: async () => {
          try {
            // Sans pagination, l'opération `oru-pg-sql` renvoie `{ rowCount, command, fields, rows }`.
            const { rows } = await directus.request<{ rows: ThesaurusRow[] }>(
              triggerFlow('GET', THESAURUS_FLOW_ID),
            );
            return { data: rows };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['thesaurus'],
      }),
    }),
  });

export const { useGetThesaurusQuery } = thesaurusApi;
